<template>
  <div class="watch-sample">
    <input type="text" id="firstValue" v-model="firstValue" />
  </div>
</template>

<script>
import Vue from 'vue'
import { value, watch } from 'vue-function-api'

export default {
  name: 'WatchSample',

  setup() {
    const firstValue = value('a')

    watch(firstValue, (newValue, oldValue) => {
      console.log(`firstValue: ${oldValue} => ${newValue}`)
    })

    return {
      firstValue
    }
  }
}
</script>
